
<div>
  <div class="mt-4 px-3 fs-6" style=" font-weight: 400; color: #A099A5;">Patient List</div>
  <p-table [value]="patientData"
           [lazy]="true"
           (onLazyLoad)="getPatients($event)"
           [paginator]="true"
           [rows]="10"
           [totalRecords]="totalRecords"
           [rowsPerPageOptions]="APP_CONFIG.dataTable.rowsPerPageOptions"
           [loading]="loading"
           responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <!--   ****************** Headers row **********************************    -->
      <tr class="table-row">
        <th *ngFor="let col of columns" [style]="col?.style" style=" white-space: nowrap;">
          {{col?.title}}
          <p-sortIcon  pSortableColumn="{{col?.field}}" *ngIf="col?.field != 'applicationStatus' && col?.field != 'applicationDate'" field="{{col?.field}}"></p-sortIcon>
        </th>
      </tr>

      <!--   ****************** Filters row **********************************    -->
      <tr>
        <th *ngFor="let col of columns">
          <ng-container *ngIf="col?.filter?.type == 'dropdown'">
            <p-columnFilter field="{{col?.field}}" matchMode="equals" [showMenu]="false">

              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [ngModel]="value" appendTo="body"
                            [options]="col?.filter?.options!"
                            (onChange)="onFilter($event.value)"
                            placeholder="{{col?.title}}"
                            [showClear]="true">
                  <ng-template let-option pTemplate="item">
                    <span>{{option.label}}</span>
                  </ng-template>
                </p-dropdown>

              </ng-template>
            </p-columnFilter>
          </ng-container>
          <ng-container *ngIf="col?.filter?.type == 'text'">
            <p-columnFilter type="text" field="{{col?.field}}" [showMenu]="false"
                            [showButtons]="false" placeholder="Search by {{col?.title}}"></p-columnFilter>
          </ng-container>
          <ng-container *ngIf="col?.filter?.type == 'numeric'">
            <p-columnFilter type="text" (keydown)="validateNumber($event)" field="{{col?.field}}" [showMenu]="false"
                            [showButtons]="false" placeholder="Search by {{col?.title}}"></p-columnFilter>
          </ng-container>
        </th>
      </tr>
    </ng-template>

    <!--   ****************** Body rows **********************************    -->
    <ng-template pTemplate="body" let-dataRow>
      <tr routerLink="/applications/patients-list/{{ dataRow.id }}" class="table-row">
        <td>{{ dataRow.id }}.</td>
        <td>{{ dataRow.mrn }}</td>
        <td class="font-medium" style="color: #47A9E4; white-space: break-spaces; ">{{ dataRow.name }}</td>
        <td>{{ dataRow.idNumber }}</td>
        <td>{{ dataRow.birthDate | date: 'dd/MM/yyyy'  }}</td>
        <td>{{ dataRow.applicationDate | date: "dd-MM-yyyy" }}</td>
        <td [class]="dataRow.applicationStatus + '-table'">{{ dataRow.applicationStatus |titlecase}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="text-center text-black-50" [attr.colspan]="columns.length!">No data found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
